export const ADD_ACCOUNT_DATA = 'ADD_ACCOUNT_DATA';
export const ADD_PROFILE_DATA = 'ADD_PROFILE_DATA';
export const ADD_DEPENDENT = 'ADD_DEPENDENT';
export const DELETE_DEPENDENT = 'DELETE_DEPENDENT';
export const EDIT_DEPENDENT = 'EDIT_DEPENDENT';
export const SET_SIGNATURE_STORED = 'SET_SIGNATURE_STORED';
